import { v4 as uuidv4 } from 'uuid';
import {
  officePhoneForbornePricing as pricing,
  officePhoneNonForbornePricing as pricingNonForborne,
  longDistanceAddOns as longDistanceAddOnspricing
} from '../../businessLogic/rates';
import {
  officePhoneFieldValues,
  twoMonthsDurationLabel
} from '../../../utils/constant';
import { getLocale } from '../../../misc';
import EN from '../../../../EN.json'
import FR from '../../../../EN.json';

const locale = getLocale();

const {
   contentfulValues: {
    officePhone: {
      opBasic,
      yes,
      tollFreePrice
    },
   }
  
} = locale === 'en-US' ? EN : FR;
export default ({ forbearance, officePhoneData }) => {
  const product = {
    lines: [],
    totalMonthly: 0,
    totalOneTime: 0
  };
  let totalMontlyMain = 0;
  if (officePhoneData && officePhoneData.length) {
    if (officePhoneData) {
      officePhoneData.forEach(
        ({
          type,
          ratePlan,
          term,
          regularOfferOfficePhone,
          limitedTimeOfferOfficePhone,
          pricingAndOffers,
          twoMonthsDuration,
          ovLines,
          tollFree,
          forbearance,
          longDistanceAddOns
        }) => {
          let subTotal = 0;
          const line = {
            type: type.value,
            ratePlan: {
              value: ratePlan.value,
              qty: 1,
              prices: {
                monthly: 0,
                oneTime: 0
              }
            },
            regularOffers: [],
            limitedTimeOffers: [],
            longDistanceAddonsOffer: []
          };
          if (forbearance.value === officePhoneFieldValues.forbearance.forborne) {
            line.ratePlan.prices.monthly = pricing[ratePlan.value][term.value];
            subTotal += pricing[ratePlan.value][term.value];

            if (twoMonthsDuration && twoMonthsDuration.value === 'Yes') {
              const deduction = pricing[ratePlan.value][term.value];
              line.regularOffers.push({
                key: uuidv4(),
                value: twoMonthsDurationLabel,
                qty: 1,
                prices: {
                  monthly: -deduction,
                  oneTime: 0
                }
              });
              subTotal -= deduction;
            }
            if (tollFree && tollFree.value === yes && [opBasic].includes(ratePlan.value)) {
              // const deduction = pricing[ratePlan.value][term.value];
              line.regularOffers.push({
                key: uuidv4(),
                value: tollFree.label,
                qty: 1,
                prices: {
                  monthly: tollFreePrice,
                  oneTime: 0
                }
              });
              subTotal += tollFreePrice;
            }
            if (limitedTimeOfferOfficePhone) {
              const deduction = pricing[ratePlan.value][term.value];
              line.limitedTimeOffers.push({
                key: uuidv4(),
                value: limitedTimeOfferOfficePhone.value,
                qty: 1,
                prices: {
                  monthly: -deduction,
                  oneTime: 0
                }
              });
              subTotal -= deduction;
            }
            if (regularOfferOfficePhone) {
              const deduction =
                pricing[ratePlan.value][regularOfferOfficePhone.value];
              line.regularOffers.push({
                key: uuidv4(),
                value: regularOfferOfficePhone.value,
                qty: 1,
                prices: {
                  monthly: deduction,
                  oneTime: 0
                }
              });
              subTotal += deduction;
            }
          } else {
            line.ratePlan.prices.monthly =
              pricingNonForborne[ratePlan.value].price;
            subTotal += pricingNonForborne[ratePlan.value].price;
            if (tollFree && tollFree.value === yes && [opBasic].includes(ratePlan.value)) {
              line.regularOffers.push({
                key: uuidv4(),
                value: tollFree.label,
                qty: 1,
                prices: {
                  monthly: tollFreePrice,
                  oneTime: 0
                }
              });
              subTotal += tollFreePrice;
            }
            if (pricingAndOffers) {
              const pricingOfferPrice =
                pricingNonForborne[ratePlan.value][pricingAndOffers.value];
              if (pricingOfferPrice) {
                line.regularOffers.push({
                  key: uuidv4(),
                  value: pricingAndOffers.value,
                  qty: 1,
                  prices: {
                    monthly: pricingOfferPrice,
                    oneTime: 0
                  }
                });
                subTotal += pricingOfferPrice;
              }
            }
          }
          if(longDistanceAddOns){
            const addition = longDistanceAddOnspricing[longDistanceAddOns.value];
            line.longDistanceAddonsOffer.push({
              key: uuidv4(),
              value: longDistanceAddOns.value,
              qty: 1,
              prices: {
                monthly: addition,
                oneTime: 0
              }
            });
            subTotal += addition;
          }
          line.totalMonthly = subTotal;
          totalMontlyMain += subTotal > 0 ? subTotal : 0;
          line.totalOneTime = 0;
          line.key = uuidv4();
          product.lines.push(line);

          ovLines.forEach(
            ({
              type: typeOv,
              ratePlan: ratePlanOv,
              term: termOv,
              regularOfferOfficePhone: regularOfferOfficePhoneOv,
              pricingAndOffers: pricingAndOffersOv,
              twoMonthsDuration: twoMonthsDurationOv,
              limitedTimeOfferOfficePhone: limitedTimeOfferOfficePhoneOv,
              forbearance,
              longDistanceAddOns: longDistanceAddOnsOV
            }) => {
              const lineOv = {
                type: typeOv.value,
                ratePlan: {
                  value: ratePlan.value,
                  qty: 1,
                  prices: {
                    monthly: 0,
                    oneTime: 0
                  }
                },
                regularOffers: [],
                limitedTimeOffers: [],
                longDistanceAddonsOffer: []
              };
              let subTotalOv = 0;

              if (forbearance.value === officePhoneFieldValues.forbearance.forborne) {
                lineOv.ratePlan.prices.monthly =
                  pricing[ratePlanOv.value][termOv.value];
                subTotalOv += pricing[ratePlanOv.value][termOv.value];
          if (tollFree && tollFree.value === yes && [opBasic].includes(ratePlan.value)) {
             lineOv.regularOffers.push({
                key: uuidv4(),
                value: tollFree.label,
                qty: 1,
                prices: {
                  monthly: tollFreePrice,
                  oneTime: 0
                }
              });
              subTotalOv += tollFreePrice;
            }
                if (
                  twoMonthsDurationOv &&
                  twoMonthsDurationOv.value === 'Yes'
                ) {
                  const deduction = pricing[ratePlanOv.value][termOv.value];
                  lineOv.regularOffers.push({
                    key: uuidv4(),
                    value: twoMonthsDurationLabel,
                    qty: 1,
                    prices: {
                      monthly: -deduction,
                      oneTime: 0
                    }
                  });
                  subTotalOv -= deduction;
                } else if (limitedTimeOfferOfficePhoneOv) {
                  const deduction = pricing[ratePlanOv.value][termOv.value];
                  lineOv.limitedTimeOffers.push({
                    key: uuidv4(),
                    value: limitedTimeOfferOfficePhoneOv.value,
                    qty: 1,
                    prices: {
                      monthly: -deduction,
                      oneTime: 0
                    }
                  });
                  subTotalOv -= deduction;
                } else if (regularOfferOfficePhoneOv) {
                  const deduction =
                    pricing[ratePlanOv.value][regularOfferOfficePhoneOv.value];
                  lineOv.regularOffers.push({
                    key: uuidv4(),
                    value: regularOfferOfficePhoneOv.value,
                    qty: 1,
                    prices: {
                      monthly: deduction,
                      oneTime: 0
                    }
                  });
                  subTotalOv += deduction;
                }
              } else {
                lineOv.ratePlan.prices.monthly =
                  pricingNonForborne[ratePlanOv.value].price;
                subTotalOv += pricingNonForborne[ratePlanOv.value].price;
                if (tollFree && tollFree.value === yes && [opBasic].includes(ratePlan.value)) {
                  lineOv.regularOffers.push({
                    key: uuidv4(),
                    value: tollFree.label,
                    qty: 1,
                    prices: {
                      monthly: tollFreePrice,
                      oneTime: 0
                    }
                  });
                  subTotalOv += tollFreePrice;
                }
                if (pricingAndOffersOv) {
                  const pricingOfferPrice =
                    pricingNonForborne[ratePlanOv.value][
                    pricingAndOffersOv.value
                    ];
                  if (pricingOfferPrice) {
                    lineOv.regularOffers.push({
                      key: uuidv4(),
                      value: pricingAndOffersOv.value,
                      qty: 1,
                      prices: {
                        monthly: pricingOfferPrice,
                        oneTime: 0
                      }
                    });
                    subTotalOv += pricingOfferPrice;
                  }
                }

              }
              if (longDistanceAddOnsOV) {
                const addition =
                  longDistanceAddOnspricing[longDistanceAddOnsOV.value];
                  lineOv.longDistanceAddonsOffer.push({
                  key: uuidv4(),
                  value: longDistanceAddOnsOV.value,
                  qty: 1,
                  prices: {
                    monthly: addition,
                    oneTime: 0
                  }
                });
                subTotalOv += addition;
              }
              lineOv.totalMonthly = subTotalOv;
              totalMontlyMain += subTotalOv > 0 ? subTotalOv : 0;
              lineOv.totalOneTime = 0;
              lineOv.key = uuidv4();
              product.lines.push(lineOv);
            }
          );
        }
      );
    }
  }

  product.totalMonthly = totalMontlyMain;

  return product;
};
